
  import { Mixins, Component } from "vue-property-decorator";

  import TablePagination from "@/mixins/tablePagination";
  import Resize from "@/mixins/resize";
  import Loading from "@/mixins/loading";

  import ETable from "@/components/ETable.vue";
  import ClientActivityForm from "./components/add.vue";

  import { clientActivityList, activityClientDict, clientActivityDict, updateClientActivityStatus } from "@/api/clientActivity";

  import { cloneDeep } from "lodash"
  
  @Component({
    inject: [],
    components: {
        ETable,
        ClientActivityForm
    }
  })
  export default class ClientActivity extends Mixins(Resize, TablePagination, Loading) {
    queryForm = {
        status: undefined,
        applicationProgram: undefined,
        activityName: ""
    }

    operateRecord = {};

    statusOptions = [
        {
            label: "启用",
            value: 1
        },
        {
            label: "禁用",
            value: 0
        }
    ]

    clientOptions = []

    locationOptions = [];

    columns = [
        {
            label: "活动名称",
            prop: "activityName",
            minWidth: 150,
            align: "center"
        },
        {
            label: "弹出位置",
            minWidth: 100,
            align: "center",
            prop: "ejectPositionDesc",
        },
        {
            label: "应用",
            width: 150,
            align: "center",
            prop: "applicationProgramListDesc",
        },
        {
            label: "开始时间",
            prop: "startTime",
            width: 160,
            align: "center"
        },
        {
            label: "结束时间",
            prop: "endTime",
            width: 160,
            align: "center"
        },
        {
            label: "操作人",
            prop: "modifiedBy",
            width: 150,
            align: "center"
        },
        {
            label: "操作时间",
            prop: "modifiedTime",
            minWidth: 180,
            align: "center"
        },
        {
            label: "操作",
            prop: "action",
            fixed: "right",
            width: 140,
            align: "center"
        },
    ]
    tableData = [];

    dialogFormVisible = false;

    async mounted(){
        this.windowResize();
        await this.getActivityClientDict();
        await this.getClientActivityDict();
        this.getData();
    }

    getClientActivityDict() {
      return clientActivityDict().then((res) => {
        this.locationOptions = res.data?.map((el) => {
          return {
            value: el.id,
            label: el.dictValue,
          }
        });
      });
    }
    getActivityClientDict() {
      return activityClientDict().then((res) => {
        this.clientOptions = res.data?.map((el) => {
          return {
            value: el.id,
            label: el.dictValue,
          }
        });
      });
    }
    getData() {
        this.hideLoading();
        this.showLoading();
        clientActivityList({
            ...this.queryForm,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
        }).then(res => {
            this.hideLoading();
            this.tableData = res.data.list;
            this.itemTotal = res.data.total;
            this.tableData.forEach((el) => {
                el.ejectPositionDesc = this.locationOptions.find((el2) => el2.value == el.ejectPosition)?.label;
                el.applicationProgramListDesc = el.applicationProgramList?.reduce((acc, cur) => {
                    return [...acc, this.clientOptions.find((el2) => el2.value == cur.applicationProgram)?.label]
                }, [])?.join("、");
                el.activityTipsImgList = el.activityTipsImgList?.map((el2) => {
                    return {
                        imgUrl: [{ url: el2.imgUrl }],
                        linkUrl: el2.linkUrl
                    }
                });
                el.applicationProgramList = el.applicationProgramList?.map((el2) => {
                    return el2.applicationProgram
                });
            })
        }).finally(() => {
            this.hideLoading();
        });
    }

    handleSearch() {
        this.resetCurrent();
        this.getData();
    }

    refreshTable() {
      this.getData();
    }

    handleEdit(row) {
        this.dialogFormVisible = true;
        if (row.id) {
            this.operateRecord = cloneDeep(row);
        } else {
          this.operateRecord = {};
        }
    }

    handleStatusChange(row) {
        updateClientActivityStatus({ activityId: row.id }).then(() => {
            this.refreshTable();
        })
    }
  }
